import React from 'react';

import PermissionsList from '../../components/PermissionsList';
import Tabs from '../../components/Tabs';
import { useGetPermissionsQuery } from '../../services/permissions';
import useTab from '../../utils/react/hooks/useTab';

import { PageContainer } from './index.styles';

const TAB_OPTIONS = [
  {
    key: 'all',
    permissionPrefix: '',
    label: 'All',
  },
  {
    key: 'NTE',
    permissionPrefix: 'NTE',
    label: 'Notes',
  },
  {
    key: 'VID',
    permissionPrefix: 'VID',
    label: 'Videos',
  },
  {
    key: 'EXM',
    permissionPrefix: 'EXM',
    label: 'Exams',
  },
  {
    key: 'TUT',
    permissionPrefix: 'TUT',
    label: 'Tutorials',
  },
];

const AdminPermissionsPage = () => {
  const [tab, setTab] = useTab({ default: 'all' });

  const { data: permissionsList, isFetching: isPermissionsListFetching } = useGetPermissionsQuery({
    prefix: TAB_OPTIONS.find((x) => x.key === tab)?.permissionPrefix,
  });

  /**
   *  Modal
   */

  return (
    <PageContainer>
      <Tabs
        options={TAB_OPTIONS}
        selectedKey={tab}
        onChange={(key) => setTab(key)}
        showIcons
      />
      <PermissionsList
        data={permissionsList?.data || []}
        loading={isPermissionsListFetching}
        columns={
          [{
            field: 'label',
            headerName: 'Label',
            width: 600,
          }]
        }
        getRowHref={(row) => `/admin/permission/${row.value}`}
      />
    </PageContainer>
  );
};
export default AdminPermissionsPage;
